'use client'
import HomeLayout from "@/components/layout/HomeLayout";
import EventsCard from "@/components/common/EventCard";
import React, {useEffect, useState} from "react";
import TrainingLayout from "@/components/layout/TrainingLayout";
import {getEventsBanner} from "@/components/features/media/mediaSlice";
import Image from "next/image";

const Events: React.FC = () => {
  const [banners, setBanners] = useState<any[]>([]);
  useEffect(() => {
    const handleGetBanner = async () => {
      try {
        const banners = await getEventsBanner();
        if (Array.isArray(banners)) {
          setBanners(banners);
        }
      } catch (err) {
        return;
      }
    };
    handleGetBanner();
  }, []);
  return (
    <HomeLayout>
      <main className="min-h-screen min-w-screen flexer flex-col pt-24 pb-6">
        <div className="container flexer flex-col gap-4 lg:gap-12">
          <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 lg:gap-6 p-4">
            {banners.length > 0 ? (
                banners.map((banner: any, index: number) => (
                    <Image
                        src={banner?.imageUrl}
                        alt="banner"
                        width="300"
                        height="300"
                        className="w-full"
                        key={index}
                    />
                ))
            ) : (
                <p className="text-sm text-center opacity-85">
                  No event available for now!
                </p>
            )}
          </div>
          <TrainingLayout step="Events">
            <div className="w-full grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 lg:gap-6">
              <EventsCard
                  image="silver"
                  value={process.env.NEXT_PUBLIC_SILVER_CREDIT}
                  details="Profit per transaction is 0.40% task contains 30 each order"
              />
              <EventsCard
                  image="bronze"
                  value={process.env.NEXT_PUBLIC_BLONZE_CREDIT}
                  details="Profit per transaction is 0.60% task contains 45 each order"
              />
              <EventsCard
                  image="gold"
                  value={process.env.NEXT_PUBLIC_GOLD_CREDIT}
                  details="Profit per transaction is 0.80% task contains 50 each order"
              />
              <EventsCard
                  image="diamond"
                  value={process.env.NEXT_PUBLIC_DIAMOND_CREDIT}
                  details="Profit per transaction is 1.00% task contains 55 each order"
              />
            </div>
          </TrainingLayout>
        </div>
      </main>
    </HomeLayout>
  );
};

export default Events;
